window.addEventListener('resize', function() {
    const dropdownItems = document.querySelector('.footer-language .dropdown-items');
    const footerLanguage = document.querySelector('.footer-language');
    
    if (dropdownItems && footerLanguage) {
        const newBottom = footerLanguage.offsetHeight - 2;
        dropdownItems.style.bottom = `${newBottom}px`;
    }
});
